module.exports = __webpack_public_path__ + "static/media/Artboard18.dda886cf.png";